export default {"src":"/_next/static/media/dhl.316a5f9d.svg","height":24,"width":150,"blurWidth":0,"blurHeight":0};